module.exports = __webpack_public_path__ + "static/img/online.d34d7ded.png";